import { render } from "./BaseLink.vue?vue&type=template&id=04c26a9a&scoped=true"
import script from "./BaseLink.vue?vue&type=script&lang=js"
export * from "./BaseLink.vue?vue&type=script&lang=js"

import "./BaseLink.vue?vue&type=style&index=0&id=04c26a9a&lang=css&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c26a9a"]])

export default __exports__